/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CategorySummary } from './CategorySummary';
export type CatalogItem = {
    id: string;
    title: string;
    description?: string | null;
    price: number;
    currency: CatalogItem.currency;
    category: CategorySummary;
    thumbnail_url?: string | null;
    preview_url?: string | null;
    preview_video_url?: string | null;
    tags: Array<string>;
    is_favorite?: boolean | null;
};
export namespace CatalogItem {
    export enum currency {
        CREDITS = 'credits',
    }
}

